import { useState } from "react";
import "./works.scss";

export default function Works() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const data = [
    {
      id: "1",
      icon: "./assets/writing.png",
      title: "Discovering discrepancies in numerical libraries",
      desc:
        "This paper addresses the problem of finding discrepancies between synonymous functions in different numerical libraries as a means of identifying incorrect behavior. ",
      img:
        "https://raw.githubusercontent.com/ucd-plse/FPDiff/master/resources/figures/pipeline-final.png",
      link:
        "https://dl.acm.org/doi/abs/10.1145/3395363.3397380",
      category:"Paper",
    },
    {
      id: "2",
      icon: "./assets/mobile.png",
      title: "Pet Adoption Speed Prediction",
      desc:
        "This is a machine learning project to predict the speed at which a pet is adopted, based on the pet’s listing on PetFinder. ",
      img:
        "https://i.pinimg.com/originals/80/d3/64/80d364e09d31fcba8af274926d4332ff.jpg",
      link:
        "https://github.com/preston4896/ecs171_pet_adoption",
      category:"Project",
    },
    {
      id: "3",
      icon: "./assets/globe.png",
      title: "Clang Libtooling Sample",
      desc:
        "A demo project of clang libtooling library for walking through c code syntax tree. ",
      img:
        "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c0/Clang_12.0.1_version_information_screenshot.png/600px-Clang_12.0.1_version_information_screenshot.png",
      link:
        "https://github.com/Xuan-Deng/Clang-Libtooling-Sample",
      category:"Project",
    },
  ];

  const handleClick = (way) => {
    way === "left"
      ? setCurrentSlide(currentSlide > 0 ? currentSlide - 1 : 2)
      : setCurrentSlide(currentSlide < data.length - 1 ? currentSlide + 1 : 0);
  };
  
  return (
    <div className="works" id="works">
      <div
        className="slider"
        style={{ transform: `translateX(-${currentSlide * 100}vw)` }}
      >
        {data.map((d) => (
          <div className="container">
            <div className="item">
              <div className="left">
                <div className="leftContainer">
                  <div className="imgContainer">
                    <img src={d.icon} alt="" />
                  </div>
                  <h2>{d.title}</h2>
                  <p>{d.desc}</p>
                  <a href={d.link}><span>{d.category}</span></a>
                </div>
              </div>
              <div className="right">
                <img
                  src={d.img}
                  alt=""
                />
              </div>
            </div>
          </div>
        ))}
      </div>
      <img
        src="assets/arrow.png"
        className="arrow left"
        alt=""
        onClick={() => handleClick("left")}
      />
      <img
        src="assets/arrow.png"
        className="arrow right"
        alt=""
        onClick={() => handleClick()}
      />
    </div>
  );
}
